import { vservice } from '@niknevis/vue-modules'
import { BaseRequestLoadingHandler } from '@/modules/shared/interfaces/base-request-loading-handler.interface'
import { TicketService } from '@/modules/ticket/services/ticket.service'

@vservice()
export class OpenTicketUseCase implements BaseRequestLoadingHandler {
  constructor(
    private readonly service: TicketService
  ) {
  }

  private loadingState: boolean = false

  private successState: boolean = false

  get isLoading() {
    return this.loadingState
  }

  get isSuccess() {
    return this.successState
  }

  execute(ticketId: number) {
    return this.service.openTicket(ticketId)
      .onStart(() => {
        this.loadingState = true
        this.successState = false
      })
      .onFinish(() => {
        this.loadingState = false
      })
      .onSuccess(() => {
        this.successState = true
      })
  }
}
